import { useRef } from "react";

import { getLocalStorageItem } from "~/lib/localStorage";
import { useSession } from "~/providers/SessionProvider";
import type { UserWithRole } from "~/types/collections";

interface AuthState {
  user: UserWithRole | null;
  hasAccount: boolean;
  isLoading: boolean;
  isAuthenticated: boolean;
  isInitialLoad: boolean;
}

/**
 * Custom hook for managing authentication state.
 * Leverages session data and local storage to determine authentication status.
 * Simulates an authenticated state in a Storybook environment for development and testing.
 */
const useAuth = (): AuthState => {
  const hasAccount = useRef<boolean>(
    Boolean(getLocalStorageItem("hasAccount"))
  );
  const { isAuthenticated, user, isLoading, isInitialLoad } = useSession();

  // Actual authentication state
  return {
    user,
    hasAccount: hasAccount.current,
    isLoading,
    isAuthenticated,
    isInitialLoad,
  };
};

export default useAuth;
